import PropTypes from 'prop-types'
import { observer } from 'mobx-react-lite'

import { formatNoteDescriptionFromBackend } from 'util/notes'
import useStyles from './styles'

const DefaultNotesBlock = ({ type, visit }) => {
  const classes = useStyles()

  return visit.notes[type] ? (
    <div className={classes.noteCard}>{formatNoteDescriptionFromBackend(visit.notes[type].description)}</div>
  ) : null
}
DefaultNotesBlock.propTypes = {
  type: PropTypes.oneOf(['history', 'exam', 'psychotherapy']).isRequired,
  visit: PropTypes.object,
}

export default observer(DefaultNotesBlock)
